/* Dormant cart watchdog. Ported from the live Booster safety net.
   Monster's /cart/update.js race goes away with Monster. This stays for the first two weeks:
   it watches POST /cart/add, and only if the variant is missing from /cart.js does it re-add
   once and refresh Dawn's cart drawer (or notification). It does nothing when the line is there.
   Remove around Nov 3, after Monster is uninstalled. */
(function () {
  if (window.__cclCartNet) return;
  window.__cclCartNet = true;
  var LOG = (window.__cclCartNetLog = []);
  var DELAY = 1500,
    MAX_RECOVER = 3;
  var pending = {};
  var recovered = {};
  var recoverCount = 0,
    timer = null,
    busy = false;

  function log(m) {
    try {
      LOG.push([Date.now(), m]);
    } catch (e) {}
  }
  function isAdd(url, method) {
    url = String(url || '');
    return (
      /^post$/i.test(method || '') &&
      /\/cart\/add(\.js)?(\?|$)/.test(url.replace(/^https?:\/\/[^/]+/, '')) &&
      url.indexOf('ccl_net=1') < 0
    );
  }
  function num(v) {
    var n = parseInt(v, 10);
    return isNaN(n) ? null : n;
  }
  function idOf(v) {
    return num(String(v == null ? '' : v).replace(/^gid:\/\/shopify\/ProductVariant\//, ''));
  }
  function parseBody(b) {
    var out = [],
      o = null,
      i;
    try {
      if (!b) return out;
      if (typeof b === 'string') {
        var s = b.trim();
        if (s.charAt(0) === '{') o = JSON.parse(s);
        else b = new URLSearchParams(s);
      }
      if (!o && b && typeof b.forEach === 'function' && typeof b.append === 'function') {
        o = { properties: {} };
        b.forEach(function (v, k) {
          var m = /^properties\[(.+)\]$/.exec(k);
          if (m) o.properties[m[1]] = v;
          else if (k === 'id' || k === 'quantity' || k === 'selling_plan') o[k] = v;
        });
      }
      if (!o) return out;
      var list = Array.isArray(o.items) ? o.items : [o];
      for (i = 0; i < list.length; i++) {
        var id = idOf(list[i].id || list[i].variant_id);
        if (id)
          out.push({
            id: id,
            quantity: num(list[i].quantity) || 1,
            properties: list[i].properties || {},
            selling_plan: list[i].selling_plan || null,
          });
      }
    } catch (e) {
      log('parse error ' + e);
    }
    return out;
  }
  function note(items) {
    if (!items.length) return;
    for (var i = 0; i < items.length; i++) pending[items[i].id] = items[i];
    clearTimeout(timer);
    timer = setTimeout(check, DELAY);
    log(
      'add seen ' +
        items
          .map(function (x) {
            return x.id + 'x' + x.quantity;
          })
          .join(',')
    );
  }
  function refreshDawn(variantId) {
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    if (!cart || typeof cart.getSectionsToRender !== 'function' || typeof cart.renderContents !== 'function') return;
    var ids = cart
      .getSectionsToRender()
      .map(function (section) {
        return section.id;
      })
      .join(',');
    return origFetch(window.location.pathname + '?sections=' + encodeURIComponent(ids), {
      credentials: 'same-origin',
    })
      .then(function (r) {
        return r.json();
      })
      .then(function (sections) {
        cart.classList.remove('is-empty');
        cart.renderContents({ id: variantId, sections: sections });
        log('dawn cart refreshed');
      })
      .catch(function (e) {
        log('refresh error ' + e);
      });
  }
  function check() {
    if (busy) {
      timer = setTimeout(check, DELAY);
      return;
    }
    var want = pending;
    pending = {};
    var ids = Object.keys(want);
    if (!ids.length) return;
    busy = true;
    origFetch('/cart.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var have = {},
          i;
        for (i = 0; i < (cart.items || []).length; i++) have[cart.items[i].variant_id] = true;
        var missing = [];
        for (i = 0; i < ids.length; i++) {
          var it = want[ids[i]];
          if (have[it.id]) continue;
          if (recovered[it.id] || recoverCount >= MAX_RECOVER) {
            log('missing but not retrying ' + it.id);
            continue;
          }
          missing.push(it);
        }
        log(
          'check: present=' +
            ids
              .filter(function (k) {
                return have[k];
              })
              .join(',') +
            ' missing=' +
            missing
              .map(function (x) {
                return x.id;
              })
              .join(',')
        );
        if (!missing.length) return;
        for (i = 0; i < missing.length; i++) recovered[missing[i].id] = true;
        recoverCount++;
        var body = {
          items: missing.map(function (x) {
            var o = { id: x.id, quantity: x.quantity };
            if (x.properties && Object.keys(x.properties).length) o.properties = x.properties;
            if (x.selling_plan) o.selling_plan = x.selling_plan;
            return o;
          }),
        };
        return origFetch('/cart/add.js?ccl_net=1', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(body),
        })
          .then(function (r) {
            log('re-add status ' + r.status + ' ' + JSON.stringify(body));
            return r.ok;
          })
          .then(function (ok) {
            if (!ok) return;
            try {
              document.dispatchEvent(new CustomEvent('ccl:cart:recovered', { detail: body }));
            } catch (e) {}
            return refreshDawn(missing[0].id);
          });
      })
      .catch(function (e) {
        log('check error ' + e);
      })
      .then(function () {
        busy = false;
      });
  }

  var origFetch = window.fetch ? window.fetch.bind(window) : null;
  if (origFetch) {
    window.fetch = function (input, init) {
      var url = (input && input.url) || input,
        method = (init && init.method) || (input && input.method) || 'GET';
      var p = origFetch.apply(this, arguments);
      if (isAdd(url, method)) {
        var items = parseBody(init && init.body);
        p.then(function (r) {
          if (!r || !r.ok) return;
          if (items.length) return note(items);
          r.clone()
            .json()
            .then(function (j) {
              note(
                parseBody(
                  JSON.stringify(
                    j.items
                      ? {
                          items: j.items.map(function (x) {
                            return { id: x.variant_id, quantity: x.quantity, properties: x.properties };
                          }),
                        }
                      : { id: j.variant_id, quantity: j.quantity, properties: j.properties }
                  )
                )
              );
            })
            .catch(function () {});
        }).catch(function () {});
      }
      return p;
    };
  }

  var XP = window.XMLHttpRequest && XMLHttpRequest.prototype;
  if (XP) {
    var oOpen = XP.open,
      oSend = XP.send;
    XP.open = function (m, u) {
      this.__cclM = m;
      this.__cclU = u;
      return oOpen.apply(this, arguments);
    };
    XP.send = function (b) {
      if (isAdd(this.__cclU, this.__cclM)) {
        var xhr = this,
          items = parseBody(b);
        xhr.addEventListener('loadend', function () {
          if (xhr.status < 200 || xhr.status >= 300) return;
          if (items.length) return note(items);
          try {
            var j = JSON.parse(xhr.responseText);
            note(
              parseBody(
                JSON.stringify(
                  j.items
                    ? {
                        items: j.items.map(function (x) {
                          return { id: x.variant_id, quantity: x.quantity, properties: x.properties };
                        }),
                      }
                    : { id: j.variant_id, quantity: j.quantity, properties: j.properties }
                )
              )
            );
          } catch (e) {}
        });
      }
      return oSend.apply(this, arguments);
    };
  }
})();
